import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ProjectNavBarComponent } from './project-nav-bar.component';

// ✅ Material modules needed by the template
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule }    from '@angular/material/icon';
import { MatListModule }    from '@angular/material/list';
import { MatButtonModule }  from '@angular/material/button';

// (Optional) for BreakpointObserver if you used it in the TS
import { LayoutModule as CdkLayoutModule } from '@angular/cdk/layout';

@NgModule({
  declarations: [ProjectNavBarComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,   // 👈 REQUIRED for <mat-sidenav-container> / <mat-sidenav>
    MatToolbarModule,   // for <mat-toolbar>
    MatIconModule,      // for <mat-icon>
    MatListModule,      // for <mat-nav-list> / <a mat-list-item>
    MatButtonModule,    // for <button mat-icon-button>
    CdkLayoutModule     // optional
  ],
  exports: [ProjectNavBarComponent]
})
export class ProjectNavBarModule {}
